import { render, staticRenderFns } from "./SelectOrAddPoiList.vue?vue&type=template&id=61c8f98d"
import script from "./SelectOrAddPoiList.vue?vue&type=script&lang=js"
export * from "./SelectOrAddPoiList.vue?vue&type=script&lang=js"
import style0 from "./SelectOrAddPoiList.vue?vue&type=style&index=0&id=61c8f98d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports